import { render, staticRenderFns } from "./MarketPromoModal.vue?vue&type=template&id=ef5b64b4&"
import script from "./MarketPromoModal.vue?vue&type=script&lang=js&"
export * from "./MarketPromoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports